<faxe-page-layout
  [toggleMenu]="toggleMenu">
  <div style="horiz-align: center">
    <img class="banner-img" src="./assets/images/matrix.gif" alt="Animated matrix background" />

    <faxe-select-race></faxe-select-race>
    <div style="margin-top: 30px; align-content: center">
      <div style="position: absolute; bottom: 60px;width: 90%">
        <p style="text-align: center; width: 100%">Förbättringsförslag till
          <a href="mailto:feedback@faxeit.se">faxeit</a>
          Tack för din medverkan!
        </p>

      </div>
    </div>
  </div>
</faxe-page-layout>




